/* @flow */
// typecheck: ignore file
import cx from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Avatar from 'components/Avatar.jsx';
import Coin from 'components/Coin.jsx';
import Glyph from 'components/Glyph.jsx';
import PotentialChatMember from 'entities/PotentialChatMember';
import Text from 'components/Text.jsx';
import TextEntities from 'lib/TextEntities';
import TextWithEntities from 'components/TextWithEntities.jsx';
import {
  deselectIndividual,
  changeResultSelection,
} from 'reducers/roleBasedMessagingSearch';

import type { IndividualRecipient, Recipient } from 'reducers/roleBasedMessagingSearch';

import './styles/RoleBasedMessagingIndividualResultItem.scss';

type Props = {
  recipient: IndividualRecipient,
  highlighted: bool,
  selectedRecipients: Recipient[],
  query: string,
  onSelect: (recipients: Recipient[]) => void,
  onDeselectIndividual: (member: PotentialChatMember) => Object,
  onMouseEnter: () => void,
  onMouseLeave: () => void,
  resultSelectionIndex: number,
  onChangeResultSelection: (selectedIndex: number) => Object,
};

class RoleBasedMessagingIndividualResultItem extends React.Component {
  props: Props;

  handleSelectIndividual(recipient: IndividualRecipient) {
    this.props.onSelect([recipient]);
  }

  // typecheck: ignore statement
  handleDeselectIndividual(e: SyntheticMouseEvent) {
    e.stopPropagation();
    const recipient = this.props.recipient;
    this.props.onDeselectIndividual(recipient.member);
  }

  renderCheck() {
    return (
      <Coin
        onClick={(e) => this.handleDeselectIndividual(e)}
        color="brand"
        size="xxxlarge">
        <Glyph name="check" color="white" size="large" solo />
      </Coin>
    );
  }

  renderIndividual = (recipient: IndividualRecipient) => {
    const { member } = recipient;
    const { selectedRecipients, query } = this.props;
    const selected = !!selectedRecipients.length;
    const parser = TextEntities.createTextMatchingParser(query);

    const handleSelect = (e) => {
      e.stopPropagation();
      if (!selected) {
        this.handleSelectIndividual(recipient);
      }
    };

    return (
      <div key={member.id} className="RoleBasedMessagingIndividualResultItem-individual">
        <div className="RoleBasedMessagingIndividualResultItem-info">
          <div className="RoleBasedMessagingIndividualResultItem-circle">
            {selected ?
              this.renderCheck() :
              <Avatar
                colorHex={member.getUser().getColor()}
                text={member.getUser().getInitials()}
                size="medium"
              />
            }
          </div>
          <div
            onClick={selected ? (e) => this.handleDeselectIndividual(e) : handleSelect}
            className="RoleBasedMessagingIndividualResultItem-name">
            <Text
              truncate
              color="pitch"
              size="small">
              {member.getName()}
            </Text>
            <Text color="koala" size="xsmall" truncate>
              <TextWithEntities
                text={member.getConnectionDescription()}
                entities={parser(member.getConnectionDescription())}
              />
            </Text>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { recipient, highlighted, selectedRecipients } = this.props;
    const selected = !!selectedRecipients.length;

    const handleSelect = (e) => {
      e.stopPropagation();
      if (!selected) {
        this.handleSelectIndividual(recipient);
      }
    };

    return (
      <li
        onMouseEnter={this.props.onMouseEnter}
        onMouseLeave={this.props.onMouseLeave}
        onClick={handleSelect}
        className={cx('RoleBasedMessagingIndividualResultItem', {
          'RoleBasedMessagingIndividualResultItem-highlighted': highlighted,
          'RoleBasedMessagingIndividualResultItem-selected': selected,
        })}
        key={recipient.id}>
        <div className="RoleBasedMessagingIndividualResultItem-content">
          {this.renderIndividual(recipient)}
        </div>
      </li>
    );
  }
}

const mapStateToDispatch = (_state: Object) => {
  return {};
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    onDeselectIndividual: deselectIndividual,
    onChangeResultSelection: changeResultSelection,
  }, dispatch);

// $FlowIssue
export default connect(mapStateToDispatch, mapDispatchToProps)(RoleBasedMessagingIndividualResultItem);



// WEBPACK FOOTER //
// ./src/chat/components/RoleBasedMessagingIndividualResultItem.jsx